<template>
  <div id="monogatary">
    <div class="monogataryBook">
      <div class="inner2">
        <p>
          渋谷ヒカリエで開催した「東京カメラ部2022写真展」で限定配布し、みなさまから大変ご好評いただきました冊子「5つの世界と、あるモノガタリ」をソニーの本屋「Reader Store」で電子書籍にてご覧いただけるようになりました。<br>
        「東京カメラ部2022写真展コラボコンテスト」の大賞5作品とそのお題となった写真が収録されています。ぜひご覧ください。
        </p>
        <div class="monogataryReadBook">
          <a target="_blank" href="https://ebookstore.sony.jp/item/LT000171556001603758/">電子書籍はこちら</a>
        </div>
      </div>
    </div>

    <section class="photoList list10senNew_01">
      <div class="inner2">
        <h2 class="area">北海道・東北エリア</h2>
        <div class="monogataryWinner">
          <h3>
            monogatary.com大賞作品<br>
            <span>星々の黄昏</span>
          </h3>
          <h4>
            著： 粟生深泥
          </h4>
          <h5 class="summaryHeader">作品概要</h5>
          <p>
            「星々の黄昏、って知ってる？」というフレーズからはじまる本作。大学のフィールドワークでペアになった主人公池谷と星野は、教室のはじっこで余り物になった者同士。地に足の着いた”仲”である2人が目指したのは、彗星の伝承が伝わるという富良野。お題写真の通り、ロマンチックな舞台で、少しづつ距離を縮めていく2人には、予想外の展開が待ち受けます...！主人公池谷の「さりげなく面倒見が良い」というキャラクター設定も、大きな魅力です(どんどん主人公がイケメンに見えていく”彗星マジック”もこの作品ならではです)。ちょっとだけエモくない2人の、ちょっとエモい車旅、お題写真と一緒にお楽しみください。
          </p>
          <div class="readNovel">
            <a target="_blank" rel="noopener noreferrer" href="https://monogatary.com/story/398053">小説を読む</a>
          </div><!-- /readNovel-->
        </div><!-- /monogataryWinner-->
        <div class="stageHeader">
          <h3>お題写真</h3>
        </div>
        <div class="stage" v-if="winningWorks[0]">
          <section class="exhPhotos photo01" :class="{ horizontalM: isHorizontal[0], verticalM: !isHorizontal[0] }" v-if="winningWorks[0]">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[0])"><img class="exhPhotoImg" :src="(winningWorks[0].imageUrlS)" alt="" @load="(event) => loadHandler(event, 0)" /></a>
          </section>
          <section class="description">
            <div class="exhPhotoInfo">
              <h3 class="photoTitle">
                日本写真100景＜四季＞2021入選作品<br>
                <b>{{winningWorks[0].title}}</b><span>&nbsp;／&nbsp;北海道 上富良野町</span>
              </h3>
              <p class="photoTitleSub">撮影： {{winningWorks[0].photographer}}</p>
              <ul v-if="isCommentaryExists(0)" class="photoCommentary">
                <li v-if="isCommentExists(0)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[0], 'comment')"><img class="" src="/img2022/expTxt.png" srcset="/img2022/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(0)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[0], 'movie')"><img class="" src="/img2022/expMovie.png" srcset="/img2022/expMovie@2x.png 2x" alt="動画解説" /></a></li>
              </ul>
            </div><!-- /exhPhotoInfo-->
            <h4>大賞作品へのコメント</h4>
            <p>日々、巷のSNS界隈に溢れかえる数多の写真の中から私の写真を選定いただいた東京カメラ部及びmonogatary.comの皆さん、そして何より、こんなに素敵な物語を紡いでいただいた粟生さんに大変感激しております。私自身も思い入れの強いこの写真の持つストーリー性の奥行きが何倍、いえいえ何百倍にも膨らんでおり、かわいい子に旅をさせた産みの親もびっくり！な貴重な体験となりました。1枚の写真から始まるとある夏の不思議な一夜の出来事を、皆さんも是非ご覧ください。</p>

            <h4>自己紹介</h4>
            <p>北海道で風景、星景、野生動物を撮影しています。「地元 北海道が大好きだ！」を原動力に、日々道内を駆け巡っています。ただ、無類のビール好きがたたり、時にはシャッターチャンスを見送ることも。カメラを始める前から道内を積極的にドライブで巡っており、北海道道の駅スタンプラリーを3回制覇。道外遠征を合わせると巡った道は計400箇所以上。作品は各種ポートフォリオをご覧ください。</p>
          </section>
        </div><!-- /stage-->

        <h2 class="area">関東エリア</h2>
        <div class="monogataryWinner">
          <h3>
            monogatary.com大賞作品<br>
            <span>ぼくと電車と彼女と自転車</span>
          </h3>
          <h4>
            著： 京都乃OBACHAN2nd
          </h4>
          <h5 class="summaryHeader">作品概要</h5>
          <p>
            「電車通学のぼくと自転車通学の彼女が登下校で出会うこともない。そんなぼくたちに、二人だけの秘密ができた。」―――ある日の放課後、なぜか“心の声”で会話ができると知った主人公。でも、会話ができる相手は、バレーボール部のエースアタッカーの女の子だけ。誰にも知られないその会話は、少しづつ、でも確実に2 人の距離を縮めていきます。高校生が大人に近づいていく、その一歩一歩。甘酸っぱい青春の1ページを、やわらかい文体と共にお届けします。部活、教室、放課後、自転車、そして彼女との淡い会話劇... 無性に高校生に戻りたくなるのは、気のせいでしょうか。“心の声”で紡ぐ「青春」を是非。
          </p>
          <div class="readNovel">
            <a target="_blank" rel="noopener noreferrer" href="https://monogatary.com/story/389307">小説を読む</a>
          </div><!-- /readNovel-->
        </div><!-- /monogataryWinner-->
        <div class="stageHeader">
          <h3>お題写真</h3>
        </div>
        <div class="stage" v-if="winningWorks[1]">
          <section class="exhPhotos photo02" :class="{ horizontalM: isHorizontal[1], verticalM: !isHorizontal[1] }" v-if="winningWorks[1]">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[1])"><img class="exhPhotoImg" :src="(winningWorks[1].imageUrlS)" alt="" @load="(event) => loadHandler(event, 1)" /></a>
          </section>
          <section class="description">
            <div class="exhPhotoInfo">
              <h3 class="photoTitle">
                日本写真100景＜四季＞2021入選作品<br>
                <b>{{winningWorks[1].title}}</b><span>&nbsp;／&nbsp;東京都 荒川区 千住</span>
              </h3>
              <p class="photoTitleSub">撮影： {{winningWorks[1].photographer}}</p>
              <ul v-if="isCommentaryExists(1)" class="photoCommentary">
                <li v-if="isCommentExists(1)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[1], 'comment')"><img class="" src="/img2022/expTxt.png" srcset="/img2022/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(1)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[1], 'movie')"><img class="" src="/img2022/expMovie.png" srcset="/img2022/expMovie@2x.png 2x" alt="動画解説" /></a></li>
              </ul>
            </div><!-- /exhPhotoInfo-->
            <h4>大賞作品へのコメント</h4>
            <p>京都乃ＯＢＡＣＨＡＮ2nd様、私の写真をお題に素敵な小説を書いていただき本当にありがとうございます。「心の声」で会話するという夢の中の出来事のような甘い青春ラブストーリーに惹きこまれ、一気に読みました。小説を読んだ人それぞれが自分の甘酸っぱい青春を思い出せる胸キュンっな作品だと思いました。私のたった一枚の写真からこんなにモノガタリが広がることに感動を覚えました。読者の皆様もこの素敵な物語を読みつつ写真も楽しんでいただき、余韻に浸っていただけたら最高に嬉しいです。</p>

            <h4>自己紹介</h4>
            <p>ご覧いただきありがとうございます。おもに首都圏でストリートスナップを撮っています。本格的に写真を始めて約6年です。最初のころは風景写真を撮っていましたが、他の人と違う自分ならではの写真がなかなか撮れずに方向転換し、ここ3年ほどはStreetPhoto中心になりました。誰もが普段見過ごしてしまう都会の美しさや、心あたたまる情景など撮って、少しでも人の心の記憶に残る写真が残せたらいいな、と思っています。よろしければSNSも覗いていただけると嬉しいです！</p>
          </section>
        </div><!-- /stage-->

        <h2 class="area">中部・近畿エリア</h2>
        <div class="monogataryWinner">
          <h3>
            monogatary.com大賞作品<br>
            <span>ひかりのもり</span>
          </h3>
          <h4>
            著： 八川羚
          </h4>
          <h5 class="summaryHeader">作品概要</h5>
          <p>
            ―――「変態だ。」ある日、主人公は川の上で「光に守られながら静かに浮かぶ男性」を見つける。このお題写真から「変態だ。」というセリフの物語が生まれてくると、一体誰が想像したでしょうか！彼は何者なのか、本当に怪しい人なのか、それとも実は真人間なのか...？謎多き展開の先には、何回も読み返したくなる、温かい物語が待っています。忙しい人にこそ、立ち止まって読んでほしい。ある種、お題写真と同じく「デトックス効果」がある作品かもしれません。
          </p>
          <div class="readNovel">
            <a target="_blank" rel="noopener noreferrer" href="https://monogatary.com/story/393639">小説を読む</a>
          </div><!-- /readNovel-->
        </div><!-- /monogataryWinner-->
        <div class="stageHeader">
          <h3>お題写真</h3>
        </div>
        <div class="stage" v-if="winningWorks[2]">
          <section class="exhPhotos photo01" :class="{ horizontalM: isHorizontal[2], verticalM: !isHorizontal[2] }" v-if="winningWorks[2]">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[2])"><img class="exhPhotoImg" :src="(winningWorks[2].imageUrlS)" alt="" @load="(event) => loadHandler(event, 2)" /></a>
          </section>
          <section class="description">
            <div class="exhPhotoInfo">
              <h3 class="photoTitle">
                日本写真100景＜四季＞2021入選作品<br>
                <b>{{winningWorks[2].title}}</b><span>&nbsp;／&nbsp;静岡県 森町</span>
              </h3>
              <p class="photoTitleSub">撮影： {{winningWorks[2].photographer}}</p>
              <ul v-if="isCommentaryExists(2)" class="photoCommentary">
                <li v-if="isCommentExists(2)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[2], 'comment')"><img class="" src="/img2022/expTxt.png" srcset="/img2022/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(2)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[2], 'movie')"><img class="" src="/img2022/expMovie.png" srcset="/img2022/expMovie@2x.png 2x" alt="動画解説" /></a></li>
              </ul>
            </div><!-- /exhPhotoInfo-->
            <h4>大賞作品へのコメント</h4>
            <p>この度は、素敵な心温まる小説と私の写真とのコラボをしていただきありがとうございます。写真は実際はリアルな世界で撮影したものとなりますが、こういった形で素敵な物語が生み出されると、写真自体にも命が宿るような感覚になりました。また、今回の機会を通して、写真の新たな表現方法に私自身気付かせていただきました。小説を書いてくださった八川羚さん、ありがとうございました！</p>

            <h4>自己紹介</h4>
            <p>1993年東京生まれ。東京在住。様々な風景の魅力を写真として表現することが好きで、週末を中心に撮影に出かけている。風景写真の中でも、カメラを始めなければ気づくことのなかった自然の雄大さや自然生命の儚さに魅力を感じ、普段は自然風景を中心に撮影している。趣味の撮影とは別で、雑誌や広告などに写真を提供したり撮影依頼を受けてその場所の魅力を伝えるための写真を撮影したりもしている。</p>
          </section>
        </div><!-- /stage-->

        <h2 class="area">中国・四国エリア</h2>
        <div class="monogataryWinner">
          <h3>
            monogatary.com大賞作品<br>
            <span>トンネルの向こう側</span>
          </h3>
          <h4>
            著： なぎそう
          </h4>
          <h5 class="summaryHeader">作品概要</h5>
          <p>
            「この写真に写っている方たちを探しています」というSNSの投稿をみた主人公。自宅にも同じ写真があり、気になって連絡してみるとまさかの展開が...！自分の家族に纏わる「思いもよらない出会いと真実」は、誰にとっても予想外で突然です。お題写真である「トンネルの写真」に最大限の伏線を張って描かれる、壮大な時間の経過に圧倒されます。主人公の「心の強さと勇気」は、まるで映画のような”成長物語”を思わせ、1枚の写真からここまで世界観を膨らませることのできる創造力に、ただただ脱帽の1作です。
          </p>
          <div class="readNovel">
            <a target="_blank" rel="noopener noreferrer" href="https://monogatary.com/story/398040">小説を読む</a>
          </div><!-- /readNovel-->
        </div><!-- /monogataryWinner-->
        <div class="stageHeader">
          <h3>お題写真</h3>
        </div>
        <div class="stage" v-if="winningWorks[3]">
          <section class="exhPhotos photo02" :class="{ horizontalM: isHorizontal[3], verticalM: !isHorizontal[3] }" v-if="winningWorks[3]">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[3])"><img class="exhPhotoImg" :src="(winningWorks[3].imageUrlS)" alt="" @load="(event) => loadHandler(event, 3)" /></a>
          </section>
          <section class="description">
            <div class="exhPhotoInfo">
              <h3 class="photoTitle">
                日本写真100景＜四季＞2021入選作品<br>
                <b>{{winningWorks[3].title}}</b><span>&nbsp;／&nbsp;岡山県 瀬戸内市 牛窓</span>
              </h3>
              <p class="photoTitleSub">撮影： {{winningWorks[3].photographer}}</p>
              <ul v-if="isCommentaryExists(3)" class="photoCommentary">
                <li v-if="isCommentExists(3)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[3], 'comment')"><img class="" src="/img2022/expTxt.png" srcset="/img2022/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(3)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[3], 'movie')"><img class="" src="/img2022/expMovie.png" srcset="/img2022/expMovie@2x.png 2x" alt="動画解説" /></a></li>
              </ul>
            </div><!-- /exhPhotoInfo-->
            <h4>大賞作品へのコメント</h4>
            <p>私の撮影した写真をお題に、素敵な小説を書いていただきありがとうございます。自分が撮影した写真が、小説とのコラボで冊子になると思うと、嬉しい気持ちで胸が一杯です。原作者のなぎそう様、本当に素晴らしい作品を執筆いただきありがとうございます。また写真を選んで頂いた関係各所の皆様方にこの場をお借りして御礼申し上げます。是非、この素敵な物語と共に、写真を楽しんで頂き、一人でも多くの方に読んで頂けたら嬉しく思います。</p>

            <h4>自己紹介</h4>
            <p>1986年岡山県で生まれ、岡山育ち。大型トラックを運転して全国各地に絶賛移動中。愛機:Canon1Dx、1Dx markⅡ。子供の保育園入園をきっかけに6年程前にカメラを購入。今となっては…と言う感じで家族を中心にのんびりと撮影しています。今後も子供達の成長記録として写真を残していきます。</p>
          </section>
        </div><!-- /stage-->

        <h2 class="area">九州・沖縄エリア</h2>
        <div class="monogataryWinner">
          <h3>
            monogatary.com大賞作品<br>
            <span>丘の上のソノ</span>
          </h3>
          <h4>
            著： yasube
          </h4>
          <h5 class="summaryHeader">作品概要</h5>
          <p>
            ある日、母親から再婚したいと告げられる主人公ソノ。すぐには受け入れられないソノは、遠く離れた大分に住む、本当の父親に会いに行くことに。娘は1人、旅に出るのです。ところが、再会した父親は、トゲトゲしさとは無縁の人柄。娘との再会に喜び、戸惑いながらも溢れる愛情に、ソノは心を許していきます。どうして両親は離婚することになったのか、なぜ父親はソノを捨ててしまったのか...至高のハートフルストーリーにご期待ください。ちなみに、この物語にはもう1人、素敵なキャラクターが...それは作品を読んでのお楽しみです。
          </p>
          <div class="readNovel">
            <a target="_blank" rel="noopener noreferrer" href="https://monogatary.com/story/396916">小説を読む</a>
          </div><!-- /readNovel-->
        </div><!-- /monogataryWinner-->
        <div class="stageHeader">
          <h3>お題写真</h3>
        </div>
        <div class="stage" v-if="winningWorks[4]">
          <section class="exhPhotos photo01" :class="{ horizontalM: isHorizontal[4], verticalM: !isHorizontal[4] }" v-if="winningWorks[4]">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[4])"><img class="exhPhotoImg" :src="(winningWorks[4].imageUrlS)" alt="" @load="(event) => loadHandler(event, 4)" /></a>
          </section>
          <section class="description">
            <div class="exhPhotoInfo">
              <h3 class="photoTitle">
                日本写真100景＜四季＞2021入選作品<br>
                <b>{{winningWorks[4].title}}</b><span>&nbsp;／&nbsp;大分県 玖珠町</span>
              </h3>
              <p class="photoTitleSub">撮影： {{winningWorks[4].photographer}}</p>
              <ul v-if="isCommentaryExists(4)" class="photoCommentary">
                <li v-if="isCommentExists(4)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[4], 'comment')"><img class="" src="/img2022/expTxt.png" srcset="/img2022/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(4)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[4], 'movie')"><img class="" src="/img2022/expMovie.png" srcset="/img2022/expMovie@2x.png 2x" alt="動画解説" /></a></li>
              </ul>
            </div><!-- /exhPhotoInfo-->
            <h4>大賞作品へのコメント</h4>
            <p>大賞作品「丘の上のソノ」を読んだ時、あの日見た光り輝く町の景色からこんなにも奥深く入り込めるような物語ができたことに心から感動しました。私が見た大分の景色の中で物語が広がり、それが写真に結びついていく様子…夢中になって読み、最後にもう一度写真を見返した時には、撮影した私さえも物語の魅力を帯びた写真に引き込まれるほどでした。原作者のyasubeさん、素晴らしい作品をありがとうございます！この素敵な物語と共に私の写真を冊子にしていただけることが本当に嬉しいです。</p>
    
            <h4>自己紹介</h4>
            <p>大分県在住､二人の子の母。子ども達を素敵に写したくてカメラを始めました。撮影では「写真は記録、思い出は財産」という想いを大切に、子ども達が楽しんだり感動したことを残しています。子どもと風景を組み合わせた写真が好きで、地元大分の魅力をSNSやメディア、コンテスト受賞を通し発信する活動もしています。私の写真からその場の空気感が伝わってくれたら嬉しいです。</p>
          </section>
        </div><!-- /stage-->
      </div><!-- /inner-->
    </section><!-- /photoList-->
  </div>
</template>

<script>

export default {
  components: {
  },
  props: [
    'winner',
    'openImageViewer'
  ],
  data () {
    return {
      winningWorks: [],
      isHorizontal: {}
    }
  },
  methods: {
    loadHandler (event, index) {
      // 縦位置横位置判定
      if (event.target.naturalWidth >= event.target.naturalHeight) {
        this.$set(this.isHorizontal, index, true)
      } else {
        this.$set(this.isHorizontal, index, false)
      }
    },
    isCommentaryExists (index) {
      return (
        this.winningWorks[index].winningWorkIntroduction && (
          this.winningWorks[index].winningWorkIntroduction.comment ||
          this.winningWorks[index].winningWorkIntroduction.youtubeUrl
        )
      )
    },
    isCommentExists (index) {
      return (
        this.winningWorks[index].winningWorkIntroduction &&
        this.winningWorks[index].winningWorkIntroduction.comment
      )
    },
    isMovieExists (index) {
      return (
        this.winningWorks[index].winningWorkIntroduction &&
        this.winningWorks[index].winningWorkIntroduction.youtubeUrl
      )
    },
    imageUrlS (work) {
      return work.imageFile.replace('_l.jpg', '_s.jpg')
    }
  },
  created () {
    this.winningWorks = this.winner.winningWorks
  }
}
</script>
<style scoped>
.photoTitleSub {
  word-break:break-all;
}
</style>
